import useHandleDbError from './useHandleDbError'

export default useHandleDbError
